import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from '@computerrock/formation-router';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Panel, DataRow} from '@ace-de/ui-components';
import * as serviceCaseSelectors from '../../service-cases/serviceCaseSelectors';

const CommissioningAdditionalVehicleInformationPanel = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translatePanel = createTranslateShorthand('commissioning_additional_vehicle_information_panel');
    const {serviceCase} = props;

    return (
        <Panel
            title={translatePanel('title.additional_information')}
            qaIdent="commissioning-additional-vehicle-information"
        >
            <div className={cx('global!ace-u-two-column-layout')}>
                <div>
                    <DataRow
                        label={translatePanel('data_row_label.key')}
                        qaIdent="sc-is-key-available"
                    >
                        {serviceCase?.isKeyAvailable
                            ? translatePanel('text.on_site')
                            : translatePanel('text.not_on_site')}
                    </DataRow>
                </div>
                <div>
                    <DataRow
                        label={translatePanel('data_row_label.drivers_license')}
                        qaIdent="sc-is-driver-license-available"
                    >
                        {serviceCase?.isDriverLicenseAvailable
                            ? translatePanel('text.on_site')
                            : translatePanel('text.not_on_site')}
                    </DataRow>
                </div>
            </div>
        </Panel>
    );
};

CommissioningAdditionalVehicleInformationPanel.propTypes = {
    serviceCase: PropTypes.object,
};

CommissioningAdditionalVehicleInformationPanel.defaultProps = {
    serviceCase: null,
};

const mapStateToProps = (state, props) => {
    const serviceCaseSelector = serviceCaseSelectors.createServiceCaseSelector();
    return {
        serviceCase: serviceCaseSelector(state, props),
    };
};

export default withRouter(connect(mapStateToProps, null)(CommissioningAdditionalVehicleInformationPanel));
